import { Fragment, useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardSubtitle,
  CardTitle,
  Col,
  Container, Row
} from "reactstrap";
import { accessRole } from "../../../helpers/access_role";
import TableComponent from "./Components/TableComponent";
import "./style.scss";

const IndexView = (props) => {
  const activeRef = useRef();
  const inactiveRef = useRef();

  const [helpdeskPicCount, setHelpdeskPicCount] = useState(0);
  
  function setCountCb(res, type) {
    setHelpdeskPicCount(res);
  }
  
  const renderTableView = () => {
    return (
      <>
        <TableComponent
          cb={setCountCb}
          ref={activeRef}
        />
      </>
    );
  };


  const renderView = () => {
    return renderTableView();
  };

  return (
    <Fragment>
      <Container fluid>
        <Row>
          <Col className="col-12">
            <Card>
              <CardBody>
                <div className="float-end">
                  <div className="d-flex" style={{ columnGap: "1rem" }}>
                    {accessRole("create") ? (
                      <Link to="helpdesk_mapping_pic.html?create">
                        <Button color="primary">Buat Mapping PIC</Button>
                      </Link>
                    ) : null}
                  </div>
                </div>
                <CardTitle>Mapping PIC</CardTitle>
                <CardSubtitle className="mb-3">Data - data Mapping PIC</CardSubtitle>
                <hr />
                {renderView()}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default IndexView;
